import { createContext } from 'react';
import { IJobSpend } from '../models/business-tools';
import { TDateSelectValues } from '../models/common';

interface IRequestData {
  startDate: string;
  endDate: string;
  poJobName?: string;
}

interface IBusinessToolsContext {
  jobSpends: IJobSpend[];
  setJobSpends: (value: IJobSpend[]) => void;
  dateSelectorValue: TDateSelectValues;
  setDateSelectorValue: (value: TDateSelectValues) => void;
  requestData: IRequestData;
  setRequestData: (value: IRequestData) => void;
  businessToolsHostName: string;
}

export const BusinessToolsContext = createContext<IBusinessToolsContext>({
  jobSpends: [],
  setJobSpends: () => null,
  dateSelectorValue: 'YTD',
  setDateSelectorValue: () => null,
  requestData: {
    startDate: '',
    endDate: '',
  },
  setRequestData: () => null,
  businessToolsHostName: '',
});
